/**
 * Canonical filter taxonomy — Atlas Chat Reports.
 *
 * Single source of truth for the five filter dimensions used by the Reports
 * flow. Value strings must match the Report Scheduling Agent's `parse-query`
 * output character-for-character, or chip pre-fill silently fails. If the
 * agent emits drifted strings, normalise here (not in consumers).
 *
 * Pure data. No React, no side effects.
 */

export const SECTORS = [
  'Advance Manufacturing',
  'Aerospace & Aviation',
  'Automotive',
  'Federal & Military',
  'Financial Services',
  'Food Sciences & Agriculture',
  'Healthcare',
  'Information Services & Software',
  'Logistics & Distribution',
  'Shale Energy & Petrochemicals',
];

export const REVENUE_RANGES = [
  '$0-$1M',
  '$1M-$10M',
  '$10M-$50M',
  '$50M-$100M',
  '$100M-$500M',
  '$500M-$1B',
  '$1B-$10B',
  '$10B+',
];

export const EMPLOYEE_RANGES = [
  '1-10',
  '11-50',
  '51-100',
  '101-250',
  '251-500',
  '501-1000',
  '1K-5K',
  '5K-10K',
  '10K+',
];

export const IPO_STATUSES = ['Public', 'Private'];

export const FUNDING_TYPES = [
  'Early Stage',
  'Growth Stage',
  'Late Stage',
  'Public',
  'Other',
];

export const FUNDING_TOTAL_RANGES = [
  '$0-$500K',
  '$500K-$2M',
  '$2M-$10M',
  '$10M-$50M',
  '$50M-$100M',
  '$100M-$500M',
  '$500M+',
];
